/**
 * Created by jonas on 2020-10-03.
 */
import {ArrayUtils} from "./ArrayUtils";

export interface IStateMatrixCoordinate {
    column: number;
    row: number;
}

export class StateMatrix<T> {
    public readonly columns: number;
    public readonly rows: number;

    constructor(initMatrix?: T[][]) {
        this._matrix = initMatrix ? ArrayUtils.cloneMatrix(initMatrix) : [];
    }

    private _matrix: T[][];

    get matrix(): T[][] {
        return this._matrix;
    }

    set matrix(value: T[][]) {
        this._matrix = value;
    }

    public initWithValue(columns: number, rows: number, initValue: T): void {
        this._matrix = [];
        for (let i: number = 0; i < columns; i++) {
            this._matrix.push([]);
            for (let j: number = 0; j < rows; j++) {
                this._matrix[i].push(initValue);
            }
        }
    }

    public getAllCoordinateForValue(value: T): IStateMatrixCoordinate[] {
        const result: IStateMatrixCoordinate[] = []
        for (let i: number = 0; i < this._matrix.length; i++) {
            for (let j: number = 0; j < this._matrix[i].length; j++) {
                if (this._matrix[i][j] === value) {
                    result.push({column: i, row: j});
                }

            }
        }
        return result;
    }
}